import { Divider, Icon, ICONS } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';
import { AccessStatus } from '../../models/Securities';
import './NoAccessLock.scss';

export interface NoAccessLockProps {
  accessStatus: AccessStatus;
}

export function NoAccessLock({ accessStatus }: NoAccessLockProps): ReactElement {
  const getLabel = (accessStatus) => {
    switch (accessStatus) {
      case AccessStatus.subscriptionRequired:
        return 'Subscribe';
      case AccessStatus.privateAccessRequired:
        return 'Request Access';
      default:
        return 'No access';
    }
  };

  return (
    <div className="no-access-lock-ctx">
      <Icon name={ICONS.LockOutline} />
      <Divider vertical className="divider" />
      {getLabel(accessStatus)}
    </div>
  );
}

export default NoAccessLock;
